import { render, staticRenderFns } from "./_base-anchor-link.vue?vue&type=template&id=cc940438&"
import script from "./_base-anchor-link.vue?vue&type=script&lang=js&"
export * from "./_base-anchor-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports